import {
    CHANGE_DEFECTIVE_GROUPS_PAGE,
    GET_ALL_DEFECTIVE_GROUPS,
    GET_ONE_DEFECTIVE_GROUP,
    SEARCH_DEFECTIVE_GROUPS,
} from '../types'

const initialState = {
    defectiveGroups: null,
    defectiveGroup: null,
    pages: '',
    page: '',
    count: '',
    keyword: '',
}

export default function defectiveGroupReducer(state = initialState, action) {
    const { type, payload } = action
    switch (type) {
        case GET_ALL_DEFECTIVE_GROUPS:
            return {
                ...state,
                defectiveGroups: payload.defectiveGroups,
                pages: payload.pages,
                page: payload.page,
                count: payload.count,
                keyword: payload.keyword,
            }
        case GET_ONE_DEFECTIVE_GROUP:
            return {
                ...state,
                defectiveGroup: payload,
            }
        case SEARCH_DEFECTIVE_GROUPS:
            return {
                ...state,
                keyword: payload.keyword,
                page: 1,
            }
        case CHANGE_DEFECTIVE_GROUPS_PAGE:
            return {
                ...state,
                page: payload,
            }
        default:
            return state
    }
}
